import React from "react"

import { Wrapper, Accordion, Item, CitationLink, ItemList } from "./styles"

const Citations = ({ items }) => (
  <Wrapper id="citations">
    <Accordion title={`${items.length} Source${items.length > 1 ? "s" : ""}`} isArticleFAQ>
      <ItemList>
        {items.map((item, idx) => (
          <Item key={item.url} id={`citation-${idx + 1}`}>
            <CitationLink href={item.url} target="_blank" rel="noreferrer">
              {item.url}
            </CitationLink>
          </Item>
        ))}
      </ItemList>
    </Accordion>
  </Wrapper>
)

export default React.memo(Citations)
